import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { GeneralService } from '../service/general.service';

@Injectable()
export class AuthInterceptorInterceptor implements HttpInterceptor {

  constructor(private generalService: GeneralService ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
  
    const accessToken = this.generalService.getToken();
    if(!accessToken)
      return next.handle(request);

    // set the header
    request = request.clone({
      setHeaders: {
        Authorization: "Bearer " + accessToken
      }
    });
    return next.handle(request).pipe(
      catchError((error) => {
        // console.log(error);
       
        if (error.status === 401) {
          this.generalService.logoutUser();
        }
        if (error.status === 403) {
          this.generalService.logoutUser();
        }
        if (error.status === 500) {
          return throwError({
            statusCode: 500,
            message: 'An error occured. Please try again later.'
          });
        }
        else {
          return throwError(error) ;
        }
      })
    );
  }
}
